import {
  MetricTimelineKey,
  MetricTimelineState,
  MetricsExplorerState,
  MetricsListScopeKey,
  MetricsListState
} from "./types";

export const buildMetricsListScopeKey = (
  projectId: string,
  environmentId: string,
  service: string
): MetricsListScopeKey =>
  [projectId, environmentId, service].map(encodeURIComponent).join("/");

export const buildMetricTimelineKey = (
  metricHref: string,
  fromUnixSeconds: number,
  toUnixSeconds: number
): MetricTimelineKey => `${metricHref}#${fromUnixSeconds}-${toUnixSeconds}`;

export const initialMetricsListState: MetricsListState = {
  status: "idle",
  data: [],
  error: null
};

export const initialMetricTimelineState: MetricTimelineState = {
  status: "idle",
  data: null,
  error: null
};

export const initialMetricsExplorerState: MetricsExplorerState = {
  lists: {},
  timelines: {}
};
